import React from 'react'
import { Button, Image, Animation } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './CardSlider.css'

class CardSlider extends React.Component {
  state = {
    currentSlide: 0
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.currentSlide !== this.state.currentSlide) {
      this.props.willChange(this.state.currentSlide)
    }
  }

  handleJump = (e, idx) => {
    this.setState({ currentSlide: idx })
  }

  handleNext = e => {
    this.setState(prevState => {
      let nextSlide = prevState.currentSlide + 1

      if(nextSlide > React.Children.count(this.props.children)-1) {
        nextSlide = 0
      }

      return {
        currentSlide: nextSlide
      }
    })
  }

  get containerWidth() {
    const totalWidth = 100000

    return { width: `${totalWidth}px` }
  }

  render() {
    return (
      <div className="Card-slider">
        <div className="Card-slider-image">
          <div className="Card-slider-images">
            {React.Children.map(this.props.children, (child, idx) => {
              if(this.state.currentSlide === idx && child.props.image)
                return <Animation name="slideInDown"><SlideImage {...child.props} /></Animation>
            })}
          </div>
        </div>

        <div className="Card-slider-content">
          <div className="Card-slider-pagination">
            {React.Children.map(this.props.children, (child, idx) => (
              <a
                onClick={e => this.handleJump(e, idx)}
                className={idx === this.state.currentSlide ? 'is-active' : ''}>{idx+1}</a>
            ))}
          </div>

          <div className="Card-slider-slides">
            {React.Children.map(this.props.children, (child, idx) => {
              if(this.state.currentSlide === idx)
                return <Animation name="slideInLeft">{child}</Animation>
            })}
          </div>      

          <Button onClick={this.handleNext} outline label="Volgende" />
        </div>
      </div>
    )
  }
}

const Slide = props => (
  <div className="Card-slides-item">
    {props.children}
  </div>
)

const SlideImage = props => (
  <div className="Card-images-item">
    <Image src={props.image} title="Slide" />
  </div>
)

export default CardSlider
export { Slide, SlideImage }